<template>
  <div class="uprid-layout">
    <div v-if="loading" class="loader"></div>
    <div v-else-if="error" class="error">
      {{ error.message || JSON.stringify(error, null, 2) }}
    </div>
    <div v-else>
      <QuestionnaireAutofill />
      <SmevRequestSync />
      <PersonalData />
      <Contracts />
      <details v-if="false">
        <summary>
          Документы, подтверждающие квалификацию и репутацию клиентов
        </summary>
        <Documents :documents="documents" />
      </details>
    </div>
  </div>
</template>

<script>
import Contracts from './Contracts.vue'
import Documents from './Documents.vue'
import QuestionnaireAutofill from './QuestionnaireAutofill.vue';
import PersonalData from './PersonalData.vue';
import SmevRequestSync from "./SmevRequestsSync";

export default {
  name: 'Uprid',
  data() {
    return {
      loading: false,
      error: null,
      documents: {}
    }
  },
  components: {
    SmevRequestSync,
    Contracts,
    Documents,
    QuestionnaireAutofill,
    PersonalData
  },
  created() {
    // this.getContacts()
    //this.getDocuments()
  },
  methods: {
    // async getContacts() {
    //   this.loading = true
    //   try {
    //     const { data } = await this.axios.get('/uprid/contracts')
    //     console.log(data)
    //     this.contracts = data
    //   } catch (e) {
    //     this.error = e
    //   } finally {
    //     this.loading = false
    //   }
    // },
    async getDocuments() {
      this.loading = true
      try {
        const { data } = await this.axios.get('/uprid/documents')
        this.documents = data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style>
.uprid-layout {
  padding: 1.25rem 2.5rem;
}

.uprid-layout details summary {
  margin-top: 2rem;
  font-size: 22px;
  font-weight: bold;
}

.loader {
  margin: 1.25rem auto;
  width: 3rem !important;
  height: 3rem !important;
}

.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// Index.vue?36536a50